// react
import { useMemo } from 'react'
// hooks
import { useTranslation } from '@/hooks'
// utils
import { canSubmitAmount } from '../utils'

export const useDepositButtonState = (params: {
  isNetworkMismatch: boolean
  depositAmount: string
  approved: boolean
  currentTokenBalance: string
  selectedToken: string
  showLayerZeroTip: boolean
  minDeposit?: number
}): {
  text: string
  disabled: boolean
  isNetworkSwitch: boolean
} => {
  const { t } = useTranslation()
  const {
    isNetworkMismatch,
    depositAmount,
    approved,
    currentTokenBalance,
    selectedToken,
    showLayerZeroTip,
    minDeposit = 10,
  } = params

  return useMemo(() => {
    if (isNetworkMismatch) {
      return {
        text: t('deposit.switchNetwork'),
        disabled: true,
        isNetworkSwitch: true,
      }
    }

    const amount = parseFloat(depositAmount || '0')
    const isETH = (selectedToken || '').toUpperCase() === 'ETH'
    const effectiveMinDeposit = isETH ? 0.001 : minDeposit
    const canSubmit = canSubmitAmount(
      depositAmount,
      currentTokenBalance || '0',
      approved
    )

    if (!depositAmount || amount === 0 || !approved) {
      return {
        text: showLayerZeroTip
          ? t('deposit.layerZeroDepositButton')
          : t('deposit.confirmDeposit'),
        disabled: true,
        isNetworkSwitch: false,
      }
    }

    if (amount < (effectiveMinDeposit as number)) {
      return {
        text: t('deposit.minDepositParsed', {
          amount: effectiveMinDeposit,
          token: selectedToken,
        }),
        disabled: true,
        isNetworkSwitch: false,
      }
    }

    return {
      text: showLayerZeroTip
        ? t('deposit.layerZeroDepositButton')
        : t('deposit.confirmDeposit'),
      disabled: !canSubmit,
      isNetworkSwitch: false,
    }
  }, [
    isNetworkMismatch,
    depositAmount,
    approved,
    currentTokenBalance,
    selectedToken,
    showLayerZeroTip,
    minDeposit,
    t,
  ])
}
